import React from 'react'
import Icon from '../../elementals/icon'
import PopupTooltip from '../../overlays/popupTooltip'
import { ColorNames } from '../../../constants/colorVars'

interface PendingTooltipProps {
  style: React.CSSProperties
}

const PendingTooltip: React.FC<PendingTooltipProps> = ({ style }) => (
  // @ts-ignore needs to be ts
  <PopupTooltip
    content='This field is not editable until the previous change to it is resolved by our team.'
    wide={false}
    position='top left'
    trigger={
      <Icon
        name='hourglass-half'
        iconStyle='solid'
        color={ColorNames.Caution}
        fitted
        style={{ paddingRight: 6, fontSize: 14, ...style }}
      />
    }
  />
)

export default PendingTooltip
